<template>
  <div class="online">
    <!-- 活动标题 -->
    <div v-wechat-title="'十里坡剑神，练级邀请...'"></div>
    <div :class="`home-wrapper2 home-${homeShow}`">
      <div class="hidden-box ignore-a"></div>
      <div class="home-page" id="home-page">
        <div class="main">
          <div class="container">
            <div class="content-box">
              <div class="content-box-center">
                <!-- 左侧 标题和等级人物 -->
                <div class="content-box-left">
                  <div class="left-content-bg"></div>
                  <div class="content-box-left-content">
                    <!-- 个人信息和邀请记录 -->
                    <div class="content-box-left-top">
                      <!-- 登录信息 -->
                      <div class="service-info" title="区服角色信息">
                        <strong class="service-info-item">{{
                          userInfo.server_name
                        }}</strong>
                        <strong class="service-info-item">{{
                          userInfo.role_name
                        }}</strong>
                        <div
                          class="service-btn change-btn"
                          @click="switchRoles()"
                          v-if="signInState"
                        >
                          切换
                        </div>
                        <div
                          class="service-btn"
                          @click="getLoginContainer()"
                          v-else
                        >
                          登录
                        </div>
                      </div>
                    </div>
                    <!-- 金龙1888完成 -->
                    <div class="finish-max" v-if="activeInfo.level >= 71"></div>
                    <!-- 左侧人物头像和等级 -->
                    <div class="figure-wrapper">
                      <div
                        class="figure-circle"
                        :class="{
                          'figure-circle-1': activeInfo.level <= 29,
                          'figure-circle-2':
                            activeInfo.level <= 59 && activeInfo.level >= 30,
                          'figure-circle-3': activeInfo.level >= 60
                        }"
                      ></div>
                      <div class="grade">
                        当前等级: {{ activeInfo.level }} 级
                      </div>
                    </div>
                    <!-- 右侧奖励 -->
                    <div class="reward-wrapper">
                      <div class="reward-wrapper-border">
                        <div class="line-box">
                          <div
                            class="line-box-item"
                            v-for="(item, index) in activeInfo.get_route"
                            :key="index"
                          >
                            <div
                              class="item-circle"
                              :class="{
                                'circle-1': [0, 4, 20, 24].includes(index),
                                'circle-2': [1, 5, 9, 21].includes(index),
                                'circle-3': [2, 10, 14, 22].includes(index),
                                'circle-4': [3, 15, 19, 23].includes(index),
                                'circle-5': [6, 8, 12, 16, 18].includes(index),
                                'circle-6': [7, 11, 13, 17].includes(index),
                                'item-circle-active':
                                  `${curNum}` === `${index + 1}` && lightShow
                              }"
                            >
                              <div
                                :class="{
                                  'circle-question': item === 0,
                                  'circle-monster': item === 1,
                                  'circle-monster-1':
                                    item === 1 &&
                                    [5, 10, 11, 15, 16, 20].includes(index),
                                  'circle-monster-2':
                                    item === 1 &&
                                    [17, 18, 21, 22, 23, 24].includes(index),
                                  'circle-monster-3':
                                    item === 1 &&
                                    [0, 1, 2, 3, 6, 7].includes(index),
                                  'circle-monster-4':
                                    item === 1 &&
                                    [4, 8, 9, 13, 14, 19].includes(index),
                                  'circle-monster-5':
                                    item === 1 && [12].includes(index)
                                }"
                              ></div>
                            </div>
                            <!-- 右连接线 -->
                            <div
                              class="item-right-line"
                              :class="{
                                'item-line-none': index % 5 === 4,
                                'item-line-active':
                                  index % 5 !== 4 &&
                                  item === 1 &&
                                  activeInfo.get_route[index + 1] === 1
                              }"
                            ></div>
                            <!-- 下连接线 -->
                            <div
                              class="item-bottom-line"
                              :class="{
                                'item-line-none': index > 19,
                                'item-line-active':
                                  index <= 19 &&
                                  item === 1 &&
                                  activeInfo.get_route[index + 5] === 1
                              }"
                            ></div>
                            <!-- 右下连接线 -->
                            <div
                              class="item-right-bottom-line"
                              :class="{
                                'item-line-none':
                                  index % 6 !== 0 ||
                                  index === activeInfo.get_route.length - 1,
                                'item-line-active':
                                  index % 6 === 0 &&
                                  index < 19 &&
                                  item === 1 &&
                                  activeInfo.get_route[index + 6] === 1
                              }"
                            ></div>
                            <!-- 左上连接线 -->
                            <div
                              class="item-left-top-line"
                              :class="{
                                'item-line-none': !(
                                  index % 4 === 0 &&
                                  index >= 5 &&
                                  index !== activeInfo.get_route.length - 1
                                ),
                                'item-line-active':
                                  index >= 5 &&
                                  index % 4 === 0 &&
                                  item === 1 &&
                                  activeInfo.get_route[index - 4] === 1
                              }"
                            ></div>
                          </div>
                        </div>
                        <div class="reward-box">
                          <div
                            v-for="(item, index) in rewardList"
                            :key="index"
                            class="reward"
                            :class="`reward-${item} reward-pos-${index + 1}`"
                          >
                            <div
                              v-show="
                                activeInfo.route_info &&
                                  activeInfo.route_info[index].is_get
                              "
                              class="reward-get"
                            ></div>
                          </div>
                        </div>
                      </div>
                      <!-- 底部时间 -->
                      <div class="end-time">
                        活动剩余时间: {{ this.diffTime }}
                      </div>
                    </div>
                  </div>
                </div>
                <!-- 右侧 -->
                <div class="content-right">
                  <!-- 顶部邀请记录和分享 -->
                  <div class="content-right-top">
                    <div class="detail-btn" @click="detailShow = true"></div>
                  </div>
                  <div class="content-right-center">
                    <!-- 情报和邀请好友 -->
                    <div class="intelligence-friend">
                      <div
                        class="friend"
                        @click="
                          userInfo.role_id
                            ? (friendShow = true)
                            : getLoginContainer()
                        "
                      ></div>
                      <div
                        class="intelligence"
                        @click="
                          userInfo.role_id
                            ? (infoShow = true)
                            : getLoginContainer()
                        "
                      ></div>
                    </div>
                  </div>
                  <!-- 剩余次数 -->
                  <div class="content-right-bottom">
                    <div
                      class="game-btn game-end-btn"
                      v-if="activeInfo.level >= 71"
                      @click="finishShow = true"
                    ></div>
                    <div
                      class="game-btn game-start"
                      @click="gameStart"
                      v-else
                    ></div>
                    <div class="game-count">
                      <span>剩余战斗次数: </span>
                      <span class="count">{{ activeInfo.times }}</span>
                    </div>
                  </div>
                  <div class="tips"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 情报-弹窗 -->
        <div @touchmove.prevent class="popup_wrap rule-wrap" v-show="infoShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="infoShow">
              <div class="rule-popup-bg">
                <div class="info-modal-content">
                  <div class="info-item info-item-1">
                    <div class="detail-info-item detail-info-item-1"></div>
                    <div class="info-item-footer">
                      <span class="info-item-footer-left">累计: </span>
                      <span class="info-item-footer-right"
                        >{{ activeInfo.other_times || 0 }}次</span
                      >
                    </div>
                  </div>
                  <div class="info-item info-item-2">
                    <div class="detail-info-item detail-info-item-2"></div>
                    <div
                      class="to-share-btn"
                      @click="(infoShow = false), (qrShow = true)"
                    ></div>
                  </div>
                </div>
              </div>
              <div class="rule-close" @click="infoShow = false"></div>
            </div>
          </transition>
        </div>

        <!-- 规则详情-弹窗 -->
        <div class="popup_wrap detail-wrap" v-show="detailShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="detailShow">
              <div class="detail-content-wrapper-bg">
                <div class="detail-content-wrapper">
                  <div class="detail-content"></div>
                </div>
              </div>
              <div class="close" @click="detailShow = false"></div>
            </div>
          </transition>
        </div>

        <!-- 好友助力-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap friend-wrap"
          v-show="friendShow"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="friendShow">
              <div class="left-bottom">
                <div>
                  今日成功邀请{{
                    (activeInfo.friend_list && activeInfo.friend_list.length) ||
                      0
                  }}/7次
                </div>
                <div class="tip">每日助力上限7次</div>
              </div>
              <div
                class="send"
                @click="(friendShow = false), (qrShow = true)"
              ></div>
              <div class="close" @click="friendShow = false"></div>
            </div>
          </transition>
        </div>

        <!-- 邀请好友-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap qr-wrap"
          v-show="qrShow"
          @click.self="qrShow = false"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="qrShow">
              <div class="qr-popup-bg">
                <div class="qr-img" id="test-wrap">
                  <img :src="shareImg" alt="分享" id="test" />
                </div>
                <div
                  class="qr-copy monitor-btn"
                  @click="onCopy()"
                  id="clipboard-btn"
                  data-event="复制邀请链接"
                  :data-clipboard-text="url"
                ></div>
              </div>
              <div class="qr-popup-bottom"></div>
            </div>
          </transition>
        </div>

        <!-- 战斗-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap game-start-wrap"
          v-show="gameStartShow"
        >
          <!-- <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"> -->
          <div class="popup-wrap-box" v-show="gameStartShow">
            <div class="game-ani"></div>
          </div>
          <!-- </transition> -->
        </div>

        <!-- 战斗结算-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap game-end-wrap"
          v-show="gameEndShow"
          @click="gameEndClick"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="gameEndShow">
              <div class="game-end-content">
                <div class="grade"></div>
                <div class="grade-num">
                  <span>LV{{ curLevel }}</span>
                  <span class="rt"></span>
                  <span>LV{{ nowLevel }}</span>
                </div>
                <div class="monster"></div>
                <div
                  class="monster-content-bg"
                  :class="`monster-content-bg-${numList[Number(curNum) - 1]}`"
                >
                  <div
                    class="monster-content"
                    :class="
                      `monster-content-${monsterList[Number(curNum) - 1]}`
                    "
                  ></div>
                </div>
                <div class="monster-title">
                  {{
                    `${numTypeList[numList[Number(curNum) - 1]]}${
                      monsterTypeList[monsterList[Number(curNum) - 1]]
                    }图鉴`
                  }}
                </div>
              </div>
            </div>
          </transition>
        </div>

        <!-- 获取全部奖励-弹窗 -->
        <div
          @touchmove.prevent
          class="popup_wrap finish-all-wrap"
          v-show="finishShow"
        >
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div
              class="popup-wrap-box"
              v-show="finishShow"
              @click="finishShow = false"
            ></div>
          </transition>
        </div>

        <!-- 注销弹窗 -->
        <div class="logout-wrap popup_wrap" v-show="logoutShow">
          <transition
            enter-active-class="animated zoomInNew"
            leave-active-class="animated zoomOutRight"
            :duration="{ enter: 1000 }"
          >
            <div class="popup-wrap-box" v-show="logoutShow">
              <h2>确定退出当前用户</h2>
              <div>
                <a href="javascript:;" @click="logoutShow = false">取消</a>
                <a href="javascript:;" @click="logoutBtn()">确认</a>
              </div>
            </div>
          </transition>
        </div>

        <!-- 提示弹窗 -->
        <div :class="'tips-wrap tips-wrap-' + tipsShow">
          <div :class="'show-' + tipsShow2">
            <p>{{ tips }}</p>
          </div>
        </div>

        <!-- 阻止点击弹出-弹窗(遮层) -->
        <div
          @touchmove.prevent
          :class="'prevent-wrap prevent-wrap-' + preventShow"
        ></div>
      </div>
      <!-- 分享相关DOM -->
      <div class="online-share-box" ref="imageDom">
        <img
          src="https://download4.qcplay.com/h5-images/active/hjwq/online/share_popup_bg.png"
        />
        <div class="share-img">
          <div class="qrcode-box">
            <div id="qrcode" class="qrcode"></div>
          </div>
        </div>
      </div>
      <!-- 登陆模块 -->
      <Login
        v-if="isShowLogin"
        v-on:channelCallback="selectCallback"
        :gameName="gameName"
        :loginTypes="loginTypes"
        downloadUrl="https://static.qcplay.com/tideng/official/"
        channelTips="UID可在游戏中—设置—UID查看"
      />
      <Os
        v-if="isShowOs"
        v-on:selectCallback="selectCallback"
        v-on:logoutCallback="osCancel"
        :gameName="gameName"
      />
    </div>
  </div>
</template>
<script>
import { Toast } from "mint-ui";
import Clipboard from "clipboard";
import Os from "@/components/os";
import Login from "@/components/login";
// import QR from "@/components/qr";
import { mapState, mapMutations, mapActions } from "vuex";
import { onGetInitDataAPI, onGameStart } from "../api";
import {
  buriedLogger,
  getDiffTime,
  wechatBrowser,
  getTimeStamp,
  getPhoneParams
} from "@/utils/utils";
import { generateQRCode, generateCanvasImage } from "@/utils/share";
// import Vconsole from "vconsole";

export default {
  components: {
    Login,
    Os
  },
  data() {
    return {
      gameName: "hjwq",
      logger: null, // 阿里监测
      user_params: {}, // 不知道是什么的信息
      rewardList: [1, 2, 3, 4, 5, 6, 1, 2, 3, 4, 5, 6], // 奖励定位类名
      numTypeList: ["", "土系", "风系", "雷系", "水系", "阴阳系", "火系"],
      numList: [
        1,
        2,
        3,
        4,
        1,
        2,
        5,
        6,
        5,
        2,
        3,
        6,
        5,
        6,
        3,
        4,
        5,
        6,
        5,
        4,
        1,
        2,
        3,
        4,
        1
      ], // 怪物战利品背景列表
      monsterTypeList: ["", "蛹", "毒蛤蟆", "蜜蜂", "酒翁怪", "多头蛇"],
      monsterList: [
        3,
        3,
        3,
        3,
        4,
        1,
        3,
        3,
        4,
        4,
        1,
        1,
        5,
        4,
        4,
        1,
        1,
        2,
        2,
        4,
        1,
        2,
        2,
        2,
        2
      ], // 怪物战利品怪物列表
      diffTime: "", // 距离结束时间差
      loginTypes: [], // sdk登录显示tab
      homeShow: false, // 主页显隐
      signInState: false, // 切换登录按钮
      logoutShow: false, // 注销弹窗
      preventShow: false, // 遮层显隐
      detailShow: false, // 详情弹窗显隐
      infoShow: false, // 情报弹窗显隐
      qrShow: false, // 邀请好友弹窗显隐
      gameEndShow: false, // 战斗结算
      curNum: 0,
      nowNum: 0,
      nowLevel: 0,
      curLevel: 0,
      gameStartShow: false,
      tipsShow: false, // 提示显示1
      tipsShow2: false, // 提示显示2
      tips: "",
      friendId: "",
      helpShow: false,
      isFinishAll: false,
      finishShow: false,
      friendShow: false,
      url: "",
      shareImg: "",
      lightShow: false,
      timer: null
    };
  },
  created() {
    // 清空store上的用户数据
    // this.setInitActiveInfo();
    // this.setInitUserInfo();
    // 埋点
    const bl = buriedLogger("hjwq", "online_page");
    this.logger = bl;
    // this.homeShow = true;
  },
  mounted() {
    this.$nextTick(() => {
      this.initTime();
      this.setActiveInfo({
        friend_list: [],
        get_route: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        times: 0,
        level: 0,
        position: 0
      });
      this.monitoringEquipment();
      this.forceLandscapeScreenHandle();
      this.onWindowSizeChanged();
      this.startLoading();
      this.getLoginContainer();
      console.log(getPhoneParams());
    });
    // new Vconsole();
  },
  computed: {
    ...mapState(["userInfo", "activeInfo", "isShowLogin", "isShowOs"])
  },
  watch: {
    userInfo: {
      handler(newValue, oldValue) {
        if (!newValue.role_id) {
          // TAG: 注销的时候
          this.url = `『新仙剑奇侠传之挥剑问情』正式上线，快快参与上线活动: https://h5.qingcigame.com/hjwq/online/enter${getTimeStamp()}`;
          this.handleShare();
        } else if (newValue.role_id !== oldValue.role_id && newValue.role_id) {
          // TAG: 初始登陆/切换角色的时候
          // const { protocol, host } = window.location;
          this.url = `『新仙剑奇侠传之挥剑问情』正式上线，快快参与上线活动: https://h5.qingcigame.com/hjwq/online/help?id=${newValue.user_id}`;
          this.initShareData(newValue);
        }
      }
    },
    activeInfo(newValue, oldValue) {
      console.log("newValue: ", newValue, "oldValue: ", oldValue);
      if (newValue.level !== oldValue.level) {
        this.curLevel = oldValue.level || 0;
        this.nowLevel = newValue.level;
      }
      if (newValue.position !== oldValue.position) {
        this.curNum = oldValue.position || 0;
        this.nowNum = newValue.position;
      }
    },
    qrShow(newValue) {
      if (newValue) {
        this.logger.sum("仙剑上线活动_二维码分享弹窗显示");
      }
    }
  },
  methods: {
    gameEndClick() {
      this.gameEndShow = false;
      this.lightShow = true;
      this.timer = setTimeout(() => {
        this.lightShow = false;
      }, 2000);
      this.activeInfo.get_route &&
        !this.activeInfo.get_route.some(item => `${item}` === "0") &&
        (this.finishShow = true);
    },
    initShareData(info) {
      const shareLink2 = `https://h5.qingcigame.com/hjwq/online/help${getTimeStamp()}?id=${
        info.user_id
      }`;
      try {
        setTimeout(() => {
          this.setShare({
            link: shareLink2,
            title: "十里坡剑神，练级邀请...",
            imgUrl:
              "https://download4.qcplay.com/qcgame-admin/4fZWdOR6UfUBuOZgDyP9EV3NJ2RRxNU9mHSWBjst.png",
            desc: "公测上线活动，练级拿壕礼，快快加入吧!"
          });
          this.qrcode(shareLink2);
          this.$nextTick(() => {
            this.generateShareImage();
          });
        }, 1000);
        // 例如：获取好友助力信息等
      } catch (err) {
        // 错误信息
        console.log("err", err);
      }
    },
    qrcode(link) {
      generateQRCode(document.getElementById("qrcode"), {
        text: link,
        colorDark: "#405978",
        colorLight: "#fff8ec",
        width: document.getElementById("qrcode").offsetWidth,
        height: document.getElementById("qrcode").offsetHeight
      });
    },
    // 分享图片设置
    generateShareImage() {
      generateCanvasImage(this.$refs.imageDom)
        .then(canvas => {
          this.shareImg = canvas.toDataURL("image/png"); // 可将 canvas 转为 base64 格式
          console.log("success: 图片生成成功");
        })
        .catch(err => {
          this.handleShare();
          this.shareImg = "https://download4.qcplay.com/h5-images/active/hjwq/online/share_popup_bg2.png";
          console.log("err: 图片生成失败", err.message);
        });
    },
    initTime() {
      this.countTime();
      setInterval(this.countTime, 1000);
    },
    countTime() {
      const timeObj = getDiffTime("2023/06/16 00:00:00");
      this.diffTime = `${timeObj.day}天${timeObj.hour}时${timeObj.minute}分`;
    },
    tipsMessage(message, times) {
      this.tipsShow = true;
      this.tips = message;
      setTimeout(() => {
        this.tipsShow2 = true;
      }, 100);
      setTimeout(() => {
        this.tipsShow2 = false;
      }, times - 200);
      setTimeout(() => {
        this.tipsShow = false;
        this.tips = "";
      }, times);
    },
    monitoringEquipment() {
      // if (!navigator.userAgent.match(/(iPhone|iPod|Android|ios)/i)) location.href = `https://h5.qingcigame.com/hjwq/online/pc${getTimeStamp()}`;
      if (
        navigator.userAgent.toLowerCase().match(/MicroMessenger/i) ==
        "micromessenger"
      ) {
        return;
      } else {
        this.paymentList = this.paymentList2;
      }
    },
    // 适配
    forceLandscapeScreenHandle() {
      if (document.activeElement.nodeName === "INPUT") return; // 兼容安卓
      let width = document.documentElement.clientWidth;
      let height = document.documentElement.clientHeight;
      var docEl = document.documentElement,
        fontH = window.innerWidth > window.innerHeight ? height : width;

      const el = document.getElementById("home-page");
      let style = "";
      const cw = document.body.clientWidth;
      const ch = document.body.clientHeight;
      console.log(
        cw / ch,
        document.body.clientWidth,
        document.body.clientHeight
      );
      if (cw / ch > 0.6 && cw / ch < 0.65) {
        document.querySelector(".content-box").style = `transform:scale(0.9)`;
      } else if (cw / ch > 0.65 && cw / ch < 0.72) {
        document.querySelector(".content-box").style = `transform:scale(0.8)`;
      } else if (cw / ch > 1 && cw > 600 && ch > 600) {
        document.querySelector(".content-box").style = `transform:scale(0.8)`;
        document.querySelector(
          ".service-info"
        ).style = `font-size:0.5rem;margin-top:0`;
        document.querySelector(".grade").style = `font-size:0.35rem`;
        document.querySelector(".game-count").style = `font-size:0.35rem`;
        document.querySelectorAll(
          ".service-info-item"
        )[0].style = `font-size:0.35rem`;
        document.querySelectorAll(
          ".service-info-item"
        )[1].style = `font-size:0.35rem`;
      }
      if (width < height) {
        // 竖版
        style = `transform:rotate(90deg);transform-origin:${width /
          2}px center;width:${height}px;height:${width}px`;
        // this.homeShow = true;
      } else {
        // 横板
        setTimeout(() => {
          document.documentElement.style.fontSize = (75 * fontH) / 750 + "px";
          style = `transform:rotate(0deg);transform-origin:${width /
            2}px center;width:${width}px;height:${height}px`;
          // this.homeShow = true;
          if (el) el.style = style;
        }, 300);
      }
      if (el) el.style = style;
    },
    onWindowSizeChanged() {
      window.addEventListener("resize", () => {
        console.log(getPhoneParams());
        this.forceLandscapeScreenHandle();
      });
    },
    isReloadWindow(event) {
      return (
        !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) &&
        ((event && event.persisted) ||
          (window.performance &&
            window.performance.navigation &&
            window.performance.navigation.type === 2))
      );
    },
    startLoading() {
      // 防止第二次进入 微信底部有一个返回条，造成布局问题
      if (this.isReloadWindow()) {
        window.location.reload();
        return;
      }
    },
    // 清空数据
    cleanData() {
      this.setUserInfo({ ...this.userInfo, role_name: "", server_name: "" });
      this.setActiveInfo({
        ...this.activeInfo,
        friend_list: [],
        get_route: [
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0,
          0
        ],
        times: 0,
        level: 0,
        position: 0
      });
      this.signInState = false;
    },
    // 切换角色
    switchRoles() {
      this.openLoginOS();
    },
    getLoginContainer() {
      onGetInitDataAPI().then(response => {
        this.homeShow = true;
        if (Number(response.code) == 200) {
          this.onInitDataCallback(response);
          this.signInState = true;
          if (!response.data.activity.get_route.includes(0)) {
            this.finishShow = true;
          }
          return;
        }
        // 请登录
        if (Number(response.code) == 401) {
          this.signInState = false;
          this.onInitDataCallback(response);
          return;
        }
        // 微信授权
        if (Number(response.code) == 302) {
          window.location.href = `${
            wechatBrowser() ? response.data.url : response.data.qq_url
          }?callback=${encodeURI(window.location.href)}`;
          return;
        }
        this.tipsMessage(response.message, 2000);
      });
    },
    // 注销按钮
    // logoutBtn() {
    //   LogoutAPI()
    //     .then((response) => {
    //       if (Number(response.code) == 200) {
    //         this.logoutShow = false;
    //         this.logoutBtnClase = false;
    //         this.cleanData();
    //         this.getLoginContainer();
    //       }
    //       this.tipsMessage(response.message, 2000);
    //   });
    // },
    selectCallback() {
      // 初始化
      this.getLoginContainer();
    },
    osCancel() {
      // 清空数据
      this.cleanData();
    },
    // TODO: 登陆弹窗demo
    openLoginOS() {
      if (this.userInfo.role_id && this.userInfo.platform !== "bilibili") {
        this.changeOsPopup(true);
      } else {
        this.changeLoginPopup(true);
      }
    },
    handleShare() {
      const shareLink = `https://h5.qingcigame.com/hjwq/online/enter${getTimeStamp()}`;
      this.setShare({
        link: shareLink,
        title: "十里坡剑神，练级邀请...",
        imgUrl:
          "https://download4.qcplay.com/qcgame-admin/4fZWdOR6UfUBuOZgDyP9EV3NJ2RRxNU9mHSWBjst.png",
        desc: "公测上线活动，练级拿壕礼，快快加入吧!"
      });
    },
    // 开始游戏
    gameStart() {
      if (this.timer) clearTimeout(this.timer);
      if (!this.userInfo.role_id) return this.getLoginContainer();
      if (!this.activeInfo.route_info.find(item => item.is_get === 0)) {
        this.finishShow = true;
        return;
      }
      onGameStart({ position: this.activeInfo.position }).then(res => {
        const { code, data } = res;
        if (Number(code) === 200) {
          this.curNum = this.activeInfo.position;
          this.showGameAni();
          this.setActiveInfo({ ...this.activeInfo, ...data });
          return;
        }
        // 请登录
        if (Number(code) === 401) {
          this.signInState = false;
          this.onInitDataCallback(res);
          return;
        }
        // 微信授权
        if (Number(code) == 302) {
          window.location.href = `${
            wechatBrowser() ? res.data.url : res.data.qq_url
          }?callback=${encodeURI(window.location.href)}`;
          return;
        }
        this.tipsMessage(res.message, 2000);
      });
    },
    // 游戏打斗动画弹窗
    showGameAni() {
      this.gameStartShow = true;
      if (this.timer) {
        clearTimeout(this.timer);
        this.lightShow = false;
      }
      setTimeout(() => {
        this.gameEndShow = true;
        this.gameStartShow = false;
      }, 1200);
    },
    showFinish() {
      this.gameEndShow = false;
      if (!this.activeInfo.route_info.find(item => item.is_get === 0)) {
        this.finishShow = true;
      }
    },
    // 复制链接
    onCopy() {
      const clipboard = new Clipboard("#clipboard-btn");
      clipboard.on("success", e => {
        Toast({ message: "复制成功", duration: 1000, className: "toasts" });
        e.clearSelection();
      });
      clipboard.on("error", e => {
        Toast({ message: "复制失败", duration: 1000, className: "toasts" });
      });
    },
    ...mapMutations([
      "setUserInfo",
      "setInitUserInfo",
      "confirmLogout",
      "setInitActiveInfo",
      "changeLoginPopup",
      "changeOsPopup",
      "setActiveInfo"
    ]),
    ...mapActions(["onInitDataCallback", "setShare"])
  }
};
</script>

<style lang="less" scoped>
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/online/index/index.vue